/* Desktop: clicking any phone (tel:) or email (mailto:) link copies the
 * value to the clipboard with a small "Copied" toast, instead of launching
 * the OS dialer/mail client (which on desktop is almost never what the
 * visitor wants). Mobile keeps the native tap-to-call / tap-to-email.
 * Applies sitewide: header tooltip, contact page, footer, everywhere.
 * If the clipboard write fails, falls back to the original link behavior. */
(() => {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  let toastEl = null;
  let toastTimer = null;
  function showToast(x, y) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.textContent = 'Copied';
      toastEl.style.cssText = [
        'position:fixed', 'z-index:9999', 'pointer-events:none',
        'padding:5px 12px', 'border-radius:6px', 'font-size:15px',
        'line-height:1.6', 'font-family:var(--font-body-family)',
        'font-style:var(--font-body-style)', 'font-weight:var(--font-body-weight)',
        'background:rgb(var(--color-background))', 'color:rgb(var(--color-foreground))',
        'border:1px solid rgba(var(--color-foreground),0.12)',
        'box-shadow:0 4px 12px rgba(0,0,0,0.12)', 'opacity:0',
        'transition:opacity 0.15s ease', 'transform:translate(-50%, -130%)',
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.style.left = `${x}px`;
    toastEl.style.top = `${y}px`;
    toastEl.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.style.opacity = '0'; }, 1100);
  }

  /* iOS + Google Maps universal links = an "Open in Google Maps?" prompt
   * that, when declined, STILL opens the maps website in the tab. Instead,
   * launch the Google Maps APP directly via its URL scheme (no prompt). The
   * web URL loads only if the app never opened (not installed) - the
   * visibilitychange listener cancels the fallback the moment the app takes
   * over, so the double-open can't happen. Android opens Google Maps links
   * cleanly on its own and keeps the plain link. */
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    const a = e.target.closest?.('a[href*="google.com/maps"]');
    if (!a) return;
    if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) return;
    e.preventDefault();
    e.stopPropagation();
    const webUrl = a.href;
    const fallback = setTimeout(() => { window.location.href = webUrl; }, 900);
    const cancelIfAppOpened = () => { if (document.hidden) clearTimeout(fallback); };
    document.addEventListener('visibilitychange', cancelIfAppOpened, { once: true });
    window.location.href = 'comgooglemaps://?q=Blackout+Audio&center=43.6644663,-79.3419642&zoom=17';
  }, true);

  document.addEventListener('click', (e) => {
    if (isMobile()) return;
    const a = e.target.closest?.('a[href^="tel:"], a[href^="mailto:"]');
    if (!a) return;
    const href = a.getAttribute('href');
    // Copy what the visitor sees for phones (the formatted number); for
    // email, the bare address regardless of display text.
    const value = href.startsWith('mailto:')
      ? href.slice(7).split('?')[0]
      : (a.textContent.trim() || href.slice(4));
    e.preventDefault();
    e.stopPropagation();
    const x = e.clientX || a.getBoundingClientRect().left + a.getBoundingClientRect().width / 2;
    const y = e.clientY || a.getBoundingClientRect().top;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value)
        .then(() => showToast(x, y))
        .catch(() => { window.location.href = href; });
    } else {
      window.location.href = href;
    }
  }, true);
})();
